import { v4 as uuidv4 } from 'uuid';
import { MESSAGE_TYPES } from '@linearb/linjs-common';
import moment from 'moment';
import { omit, sample } from 'lodash';

const generateReposMessageItems = count => {
  const items = [];
  const isRead = Array(10).fill(undefined);
  isRead.push('true');
  const randomDate = (start, end) => {
    return new Date(start + Math.random() * (end - start));
  };
  items.push({
    type: MESSAGE_TYPES.GIT_INTEGRATION_DELETED,
    classification: 'ALERT',
    state: 'active',
    created_at: moment(),
    is_read: false,
    extra_data: {
      sensor_authorization_id: 4407,
      sensor_authorization_name: 'My Test Integration',
      sensor_id: 3
    },
    dedup_key: uuidv4()
  });
  items.push({
    type: MESSAGE_TYPES.REACHED_LIMIT_REPOS,
    classification: 'ALERT',
    state: 'active',
    created_at: moment(),
    is_read: false,
    extra_data: {
      sensor_authorization_id: 4407,
      license_max_repos: 2000
    },
    dedup_key: uuidv4()
  });
  const messageTypesWithoutCapLimit = omit(
    MESSAGE_TYPES,
    MESSAGE_TYPES.REACHED_LIMIT_REPOS
  );
  for (let i = 0; i < count; ++i) {
    items.push({
      type: sample(Object.values(messageTypesWithoutCapLimit)),
      classification: 'ALERT',
      state: 'active',
      created_at: randomDate(moment().subtract(30, 'day'), moment()),
      is_read: sample([true, false]),
      extra_data: {
        repos: [
          {
            name: 'linweb',
            http_url: 'https://github.com/Talhashahar/wise_trash.git'
          },
          {
            name: 'linrest',
            http_url: 'https://github.com/Talhashahar/wise_trash.git'
          },
          {
            name: 'sls-custom-dashboard',
            http_url: 'https://github.com/Talhashahar/wise_trash.git'
          },
          {
            name: 'linpy',
            http_url: 'https://github.com/Talhashahar/wise_trash.git'
          },
          {
            name: 'linpr',
            http_url: 'https://github.com/Talhashahar/wise_trash.git'
          },
          {
            name: 'long-Test-name-for-check',
            http_url: 'https://github.com/Talhashahar/wise_trash.git'
          },
          {
            name: 'audit',
            http_url: 'https://github.com/Talhashahar/wise_trash.git'
          },
          {
            name: 'Test8',
            http_url: 'https://github.com/Talhashahar/wise_trash.git'
          },
          {
            name: 'Test9',
            http_url: 'https://github.com/Talhashahar/wise_trash.git'
          }
        ],
        sensor_authorization_id: 9206
      },
      dedup_key: uuidv4()
    });
  }
  return items;
};

export let MESSAGES_MOCK = generateReposMessageItems(30).sort(
  (a, b) =>
    moment(b.created_at).format('YYYYMMDD') -
    moment(a.created_at).format('YYYYMMDD')
);

export const getMessages = async () => {
  return Promise.resolve(MESSAGES_MOCK);
};

export const markMessagesAsRead = async messageIds => {
  MESSAGES_MOCK = MESSAGES_MOCK.map(message => ({
    ...message,
    ...(messageIds.includes(message.dedup_key) ? { is_read: true } : {})
  }));
  return Promise.resolve();
};

export const removeMessages = async messageIds => {
  MESSAGES_MOCK = MESSAGES_MOCK.filter(
    ({ dedup_key }) => dedup_key !== messageIds
  );
  return Promise.resolve();
};
